import { render, staticRenderFns } from "./McmCard.vue?vue&type=template&id=644e80c7&scoped=true&"
import script from "./McmCard.vue?vue&type=script&lang=ts&"
export * from "./McmCard.vue?vue&type=script&lang=ts&"
import style0 from "./McmCard.vue?vue&type=style&index=0&id=644e80c7&lang=scss&scoped=true&"
import style1 from "./McmCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e80c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardActions,VCardText,VDivider})
